export type DashboardState = {
    autoRedirectBannerShown: boolean;
    trendCardDays: number;
    deviceTrendCardDays: number;
    trendLinesEnabled: { [channelIdDeviceId: string]: boolean };
    hoveredTrendline: { channelId: number; deviceId: string } | undefined;
    inActiveLogOut: boolean;
    isLocationRefresh: boolean;
};

export const initialDashboardState: DashboardState = {
    autoRedirectBannerShown: false,
    trendCardDays: 1,
    deviceTrendCardDays:1,
    trendLinesEnabled: {},
    hoveredTrendline: undefined,
    inActiveLogOut: false,
    isLocationRefresh: false,
};

export const isTrendlineEnabled = (
    trendlinesEnabled: { [channelIdDeviceId: string]: boolean },
    channelId: number,
    deviceId: string
): boolean => {
    const channelIdDeviceId = `${channelId}-${deviceId}`;

    return channelIdDeviceId in trendlinesEnabled ? trendlinesEnabled[channelIdDeviceId] : true;
};
